/**
 * Creation source of the plan
 */ /**
 * Possible values for creationSourceKind
 */ export var PlanCreationSourceKind = /*#__PURE__*/ function(PlanCreationSourceKind) {
    /** External creation source */ PlanCreationSourceKind["External"] = "external";
    /** Publication creation source */ PlanCreationSourceKind["Publication"] = "publication";
    return PlanCreationSourceKind;
}({});
